"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _dropdownMenu = require("@design/ui/dropdown-menu");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var ActionOverflowMenu = function ActionOverflowMenu(_ref) {
  var items = _ref.items;
  if (items.length === 0) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenu, {
    modal: false,
    "data-sentry-element": "DropdownMenu",
    "data-sentry-component": "ActionOverflowMenu",
    "data-sentry-source-file": "ActionOverflowMenu.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuTrigger, {
      asChild: true,
      "data-sentry-element": "DropdownMenuTrigger",
      "data-sentry-source-file": "ActionOverflowMenu.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
        variant: "outline",
        size: "sm",
        "aria-label": "More actions",
        "data-sentry-element": "Button",
        "data-sentry-source-file": "ActionOverflowMenu.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.MoreHorizIcon, {
          "data-sentry-element": "MoreHorizIcon",
          "data-sentry-source-file": "ActionOverflowMenu.tsx"
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuContent, {
      align: "end",
      className: "w-auto",
      "data-sentry-element": "DropdownMenuContent",
      "data-sentry-source-file": "ActionOverflowMenu.tsx",
      children: items.map(function (item) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuItem, {
          onSelect: item.onSelect,
          children: item.label
        }, item.key);
      })
    })]
  });
};
var _default = exports.default = ActionOverflowMenu;